import React from 'react'
import styles from './styles.css'
import MeIcon from 'react-icons/lib/md/person'
import MeOthersIcon from 'react-icons/lib/md/person-add'
import OthersIcon from 'react-icons/lib/md/people'
import { Link, withRouter } from 'react-router'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import SignIcon from 'react-icons/lib/md/assignment-turned-in'
import withOrganization from 'App/Decorators/withOrganization'
import LogoLoading from 'src/App/components/LogoLoading'
import contextUrl from '../../../Root/contextUrl';
import get from 'lodash/get'
import {forgotPassword} from 'meteor-apollo-accounts'
import autobind from 'autobind-decorator'
import { withApollo } from 'react-apollo'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withOrganization
@withGraphQL(
  gql`
    query myDocumentsToSign($organizationId: String) {
      myDocumentsToSign(organizationId: $organizationId) {
        totalCount
        items {
          _id
          name
        }
      }
    }
  `,
  { loading: <LogoLoading /> }
)

@withGraphQL(gql`
  query me {
    me {
      _id
      emails {
        address
        verified
      }
      isActive
      roles
      isSimpleAccount
      hasPassword
      lastKnownLocation {
        date
      }
    }
  }
`)

@withGraphQL(
  gql`
    query myFeaDocumentsToSign($organizationId: String) {
      myFeaDocumentsToSign(organizationId: $organizationId) {
        totalCount
        items {
          _id
          name
        }
      }
    }
  `,
  { loading: <LogoLoading /> }
)

@withRouter
@withApollo
@withMessage
export default class Main extends React.Component {
  
  state={}
  
  static propTypes = {
    router: PropTypes.object,
    me: PropTypes.func,
    myDocumentsToSign: PropTypes.object,
    myFeaDocumentsToSign: PropTypes.object,
    client: PropTypes.object,
    showMessage: PropTypes.func
  }

  renderPendingContracts() {
    const pendingDoc = 
     this.props.myDocumentsToSign.items.map((doc,index) => {
      if(index < 5){
        return (
          <tr
            style={{ cursor: 'pointer' }}
            key={doc._id}
            onClick={() => this.props.router.push(`/documents/${doc._id}`)}
          >
            <td>
              <SignIcon />
            </td>
            <td>{doc.name}</td>
          </tr>
        )
      }
    })
    return pendingDoc
  }

  renderButtonPending(){
    const pendingDocs = this.props.myDocumentsToSign
    if(pendingDocs){
      if(pendingDocs.totalCount >= 6){
        return (
          <div className={styles.buttons}>
            <Button primary onClick={() => this.props.router.push(`/documents/ownpendingdocuments`)}>Tienes {pendingDocs.totalCount - 5} Documentos Más Sin Firmar</Button>
          </div>
        )
      }
    }
  }

  renderPendingFeaContracts() {
    return this.props.myFeaDocumentsToSign.items.map(doc => {
      return (
        <tr
          style={{ cursor: 'pointer' }}
          key={doc._id}
          onClick={() => this.props.router.push(`/documents/${doc._id}`)}
        >
          <td>
            <SignIcon />
          </td>
          <td>{doc.name}</td>
        </tr>
      )
    })
  }

  renderToSign() {
    const documentsToSign = this.props.myDocumentsToSign
      ? this.props.myDocumentsToSign.totalCount
      : null
    if (!documentsToSign) return
    if (documentsToSign === 1) {
      const doc = this.props.myDocumentsToSign.items[0]
      return (
        <div className="section">
          <div className="header">
            <h1>Tienes un contrato por firmar</h1>
          </div>
          <div className="content">
            <div>{doc.name}</div>
            <br />
            <Button
              primary
              onClick={() => this.props.router.push(`/documents/${doc._id}`)}
            >
              Ver
            </Button>
          </div>
        </div>
      )
    }
    return (
      <div className="section">
        <div className="header">
          <h1>Tienes contratos por firmar</h1>
        </div>
        <div className="paginated-table table hoverable">
          <table>
            <thead>
              <tr>
                <th />
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>{this.renderPendingContracts()}</tbody>
          </table>
        </div>
      </div>
    )
  }

  renderFeaToSign() {
    const feaDocumentsToSign = this.props.myFeaDocumentsToSign
      ? this.props.myFeaDocumentsToSign.totalCount
      : null
    if (!feaDocumentsToSign) return
    if (feaDocumentsToSign === 1) {
      const doc = this.props.myFeaDocumentsToSign.items[0]
      return (
        <div className="section">
          <div className="header">
            <h1>Tienes un contrato que requiere firma electrónica avanzada</h1>
          </div>
          <div className="content">
            <div>{doc.name}</div>
            <br />
            <Button
              primary
              onClick={() => this.props.router.push(`/documents/${doc._id}`)}
            >
              Ver
            </Button>
          </div>
        </div>
      )
    }
    return (
      <div className="section">
        <div className="header">
          <h1>Tienes contratos que requieren firma electrónica avanzada</h1>
        </div>
        <div className="paginated-table table hoverable">
          <table>
            <thead>
              <tr>
                <th />
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>{this.renderPendingFeaContracts()}</tbody>
          </table>
        </div>
      </div>
    )
  }

  massiveSign(){

  }

  renderSignInfo(){
    var context = contextUrl;
    if(context === 'pi.tufirma.digital' || context === 'test.tufirma.digital' || context === 'portalinmobiliario.tufirma.digital' ){
      return ( 
        <div>
          <p><b>Buenas prácticas de firma:</b></p> 
          <ul>
            <li>Recuerda siempre validar los carnets de los firmantes</li>
            <li>Exige a los firmantes que siempre utilicen el mismo correo y número de teléfono que usan en TUFIRMA</li>
          </ul>
          
        </div>
        
          
        );
    }
  }

  renderSignMenu(isSimpleAccount){
    if(isSimpleAccount)
      return 
    else {
      return (
          <div className="section">
          <div className="header">
            <h1>¿ Quién quiere firmar ?</h1>          
            {this.renderSignInfo()}
          </div>
          <div className="content">
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <Link to="/sign/me" className={styles.button}>
                  <MeIcon size={60} />
                  <div>Yo</div>
                </Link>
              </div>
              <div className="col-xs-12 col-sm-4">
                <Link to="/sign/others?and=me" className={styles.button}>
                  <MeOthersIcon size={60} />
                  <div>Yo & otros</div>
                </Link>
              </div>
              <div className="col-xs-12 col-sm-4">
                <Link to="/sign/others" className={styles.button}>
                  <OthersIcon size={60} />
                  <div>Otros</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderNoPassword(hasPassword){
    if(!hasPassword){
      return(
        <div className="section">
          <div className="header">
            <h1>Completa tu perfil creando una contraseña</h1>          
          </div>
          <div className="content">Recuerda crear tu contraseña para que siempre 
                tengas acceso a tus documentos, en caso contrario deberás recuperar contraseña la próxima vez que ingreses.
                <br/><br/>
                <Button primary loading={this.state.isLoading} onClick={() => this.initPasswordCreation() } >
                  Iniciar proceso de creación de contraseña
                </Button>
            </div>
        </div>
      )
    }
  }

  @autobind
  async initPasswordCreation(){
    const me = get(this.props, 'me') || {}
    this.setState({isLoading: true})
    try{
      
      let myEmail = me.emails[0].address
      await forgotPassword( { email: myEmail }, this.props.client) 
      this.props.showMessage('Las instrucciones fueron enviadas a su correo')
    } catch (e) {
      alert("Error al forgot");
    }
    this.setState({isLoading: false})
  }

  render() {

    console.log('route /Sign/Main');
    const me = get(this.props, 'me') || {}

    return (
      <div className={styles.container}>
        {this.renderToSign()}
        {this.renderButtonPending()}
        {this.renderFeaToSign()}
        {this.renderNoPassword(me.hasPassword)}
        {this.renderSignMenu(me.isSimpleAccount)}  
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Main/index.js